;var DB = [
  {
    "name": "&nbsp;",
    "value": 0,
    "date": "01/01/2007",
    "extra": ""
  },
  {
    "name": "Colar Mel",
    "value": 21000,
    "date": "11/05/2016",
    "extra": "Cabral - Joalheria AB"
  },
  {
    "name": "Pulseira Ala Au B",
    "value": 98000,
    "date": "15/05/2013",
    "extra": "Cabral - Joalheria AB"
  },
  {
    "name": "Brinco Ala múltiplo Au B",
    "value": 63000,
    "date": "15/05/2013",
    "extra": "Cabral - Joalheria AB"
  },
  {
    "name": "Anel Blues Au B",
    "value": 79000,
    "date": "15/05/2013",
    "extra": "Cabral - Joalheria AB"
  },
  {
    "name": "Anel imperial Passion",
    "value": 65000,
    "date": "19/12/2012",
    "extra": "Cabral - Joalheria AB"
  },
  {
    "name": "Pulseira Soul com diamante",
    "value": 158000,
    "date": "19/12/2012",
    "extra": "Cabral - Joalheria AB"
  },
  {
    "name": "Brinco clímax com diamante",
    "value": 77000,
    "date": "19/12/2012",
    "extra": "Cabral - Joalheria AB"
  },
  {
    "name": "Anel Mozart com turmalina",
    "value": 159000,
    "date": "18/07/2012",
    "extra": "Cabral - Joalheria AB"
  },
  {
    "name": "Colar Blue Paradise com turmalina",
    "value": 229000,
    "date": "18/07/2012",
    "extra": "Cabral - Joalheria AB",
    "description": "O ex-governador Sérgio Cabral deu o equivalente a R$ 1 milhão em joias como presentes de aniversário para a mulher Adriana Ancelmo. Em 18 de julho de 2012, a então primeira-dama completou 42 anos. No mesmo dia, Carlos Miranda, apontado pelos investigadores como operador financeiro de Cabral, comprou na joalheria Antonio Bernardo, em Ipanema, um colar Blue Paradise com Turmalina, entre outras peças (G1 06/12/2016)"
  },
  {
    "name": "Brinco espeto de turmalina paraíba",
    "value": 612000,
    "date": "18/07/2012",
    "extra": "Cabral - Joalheria AB",
    "description": "A força-tarefa da Lava-Jato já tem em mãos todas as notas fiscais das compras de 460 peças feitas para Sérgio Cabral em dinheiro vivo. O volume de gastos é maior do que os investigadores estimavam no início da Operação Calicute e totaliza cerca de R$ 5,7 milhões, gastos em anéis, colares, e pares de brinco como o de turmalina paraíba, com diamantes de R$ 612 mil (O Globo 01/12/2016)"
  },
  {
    "name": "Anel Leblon laranja Au B",
    "value": 72000,
    "date": "11/06/2012",
    "extra": "Cabral - Joalheria AB"
  },
  {
    "name": "Brinco Volúpia",
    "value": 82000,
    "date": "10/04/2012",
    "extra": "Cabral - Joalheria AB"
  },
  {
    "name": "Anel Gênesis com diamante",
    "value": 78000,
    "date": "10/04/2012",
    "extra": "Cabral - Joalheria AB"
  },
  {
    "name": "Anel Blue Cluster Au B",
    "value": 48800,
    "date": "13/07/2011",
    "extra": "Cabral - Joalheria AB"
  },
  {
    "name": "Brinco Blue CLuster Au B",
    "value": 125100,
    "date": "13/07/2011",
    "extra": "Cabral - Joalheria AB"
  },
  {
    "name": "Anel Anêmona com turmalinas",
    "value": 31950,
    "date": "18/05/2011",
    "extra": "Cabral - Joalheria AB"
  },
  {
    "name": "Anel Folhagem com esmeralda",
    "value": 67050,
    "date": "18/05/2011",
    "extra": "Cabral - Joalheria AB"
  },
  {
    "name": "Brinco Folhagem com esmeralda",
    "value": 138960,
    "date": "19/05/2011",
    "extra": "Cabral - Joalheria AB"
  },
  {
    "name": "Brinco Rubro Au B",
    "value": 162000,
    "date": "23/12/2010",
    "extra": "Cabral - Joalheria AB"
  },
  {
    "name": "Anel Rubro Au B",
    "value": 158000,
    "date": "23/12/2010",
    "extra": "Cabral - Joalheria AB"
  },
  {
    "name": "Anel Ar com diamante",
    "value": 23400,
    "date": "04/06/2010",
    "extra": "Cabral - Joalheria AB"
  },
  {
    "name": "Brinco Gaudi com diamantes",
    "value": 198000,
    "date": "18/05/2010",
    "extra": "Cabral - Joalheria AB",
    "description": "Um relatório entregue à força-tarefa da Lava Jato no Rio pela joalheria Antonio Bernardo relata que os cheques entregues por Cabral nas compras das joias eram apenas para garantir os pagamentos, mas depois eram devolvidos e trocados por dinheiro em espécie. Entre os itens mais caros estão um conjunto de brincos com diamantes de R$ 198 mil (JB 02/12/2016)"
  },
  {
    "name": "Aliança Eu te amo",
    "value": 19000,
    "date": "18/05/2010",
    "extra": "Cabral - Joalheria AB"
  },
  {
    "name": "Anel Dream",
    "value": 8300,
    "date": "31/03/2010",
    "extra": "Cabral - Joalheria AB"
  },
  {
    "name": "Pulseira Dream",
    "value": 23000,
    "date": "31/03/2010",
    "extra": "Cabral - Joalheria AB"
  },
  {
    "name": "Brinco Helicônia maior",
    "value": 58000,
    "date": "31/03/2010",
    "extra": "Cabral - Joalheria AB"
  },
  {
    "name": "Pulseira Íntimo",
    "value": 57000,
    "date": "23/12/2009",
    "extra": "Cabral - Joalheria AB"
  },
  {
    "name": "Brinco Íntimo retangular",
    "value": 26000,
    "date": "23/12/2009",
    "extra": "Cabral - Joalheria AB"
  },
  {
    "name": "Anel Janela",
    "value": 7000,
    "date": "23/12/2009",
    "extra": "Cabral - Joalheria AB"
  },
  {
    "name": "Brinco Fractalis especial II",
    "value": 60000,
    "date": "23/12/2008",
    "extra": "Cabral - Joalheria AB"
  },
  {
    "name": "Anel Tech com diamante",
    "value": 50000,
    "date": "23/12/2008",
    "extra": "Cabral - Joalheria AB"
  },
  {
    "name": "Brinco Leblon laranja Au B maior",
    "value": 50000,
    "date": "15/08/2013",
    "extra": "Adriana Ancelmo - Joalheria AB"
  },
  {
    "name": "Brinco espeto Coruja",
    "value": 18950,
    "date": "31/05/2012",
    "extra": "Adriana Ancelmo - Joalheria AB"
  },
  {
    "name": "Terço Angel com diamantes II Au B",
    "value": 121000,
    "date": "16/02/2012",
    "extra": "Adriana Ancelmo - Joalheria AB"
  },
  {
    "name": "Anel Lumière com beads",
    "value": 38600,
    "date": "16/02/2012",
    "extra": "Adriana Ancelmo - Joalheria AB"
  },
  {
    "name": "Brinco Ray com pérola",
    "value": 55900,
    "date": "16/02/2012",
    "extra": "Adriana Ancelmo - Joalheria AB"
  },
  {
    "name": "Brinco Prisma múltiplo",
    "value": 10000,
    "date": "23/03/2011",
    "extra": "Adriana Ancelmo - Joalheria AB"
  },
  {
    "name": "Brinco Asteca 86",
    "value": 10000,
    "date": "23/03/2011",
    "extra": "Adriana Ancelmo - Joalheria AB"
  },
  {
    "name": "Terço Angel com diamantes Au B",
    "value": 48800,
    "date": "05/10/2010",
    "extra": "Adriana Ancelmo - Joalheria AB"
  },
  {
    "name": "Brinco Sucata",
    "value": 22000,
    "date": "05/10/2010",
    "extra": "Adriana Ancelmo - Joalheria AB"
  },
  {
    "name": "Brinco Pólen Triplo especial",
    "value": 80400,
    "date": "28/03/2011",
    "extra": "Adriana Ancelmo - Joalheria AB"
  },
  {
    "name": "Brinco com pérolas da cliente",
    "value": 28000,
    "date": "21/06/2010",
    "extra": "Adriana Ancelmo - Joalheria AB"
  },
  {
    "name": "Aliança tipo Yes",
    "value": 2797,
    "date": "18/06/2010",
    "extra": "Adriana Ancelmo - Joalheria AB"
  },
  {
    "name": "Aliança tipo Yes",
    "value": 2797,
    "date": "18/06/2010",
    "extra": "Adriana Ancelmo - Joalheria AB"
  },
  {
    "name": "Anel Contraste com pedra",
    "value": 7798,
    "date": "18/06/2010",
    "extra": "Adriana Ancelmo - Joalheria AB"
  },
  {
    "name": "Aliança Eterna especial",
    "value": 46400,
    "date": "15/12/2009",
    "extra": "Adriana Ancelmo - Joalheria AB"
  },
  {
    "name": "Brinco Dress maior ST",
    "value": 7900,
    "date": "15/12/2009",
    "extra": "Adriana Ancelmo - Joalheria AB"
  },
  {
    "name": "Anel Puzzle com diamante C",
    "value": 13700,
    "date": "15/12/2009",
    "extra": "Adriana Ancelmo - Joalheria AB"
  },
  {
    "name": "Brinco Fieira",
    "value": 4000,
    "date": "15/12/2009",
    "extra": "Adriana Ancelmo - Joalheria AB"
  },
  {
    "name": "Anel Passagem Au B",
    "value": 4757,
    "date": "06/11/2009",
    "extra": "Adriana Ancelmo - Joalheria AB"
  },
  {
    "name": "Anel Passagem Au B",
    "value": 4757,
    "date": "06/11/2009",
    "extra": "Adriana Ancelmo - Joalheria AB"
  },
  {
    "name": "Anel Passagem",
    "value": 4757,
    "date": "06/11/2009",
    "extra": "Adriana Ancelmo - Joalheria AB"
  },
  {
    "name": "Brinco Sol Nascente",
    "value": 3100,
    "date": "16/09/2008",
    "extra": "Adriana Ancelmo - Joalheria AB"
  },
  {
    "name": "Brinco Fascínio Especial",
    "value": 200000,
    "date": "28/08/2008",
    "extra": "Adriana Ancelmo - Joalheria AB",
    "description": "Adriana Ancelmo era uma cliente tão especial da Antonio Bernardo que, em 28 de agosto de 2008, ela deu oito cheques de 25.000 reais cada – em nome de seu escritório de advocacia – para arrematar por 200.000 reais uma peça exclusiva que levou seu nome: Brinco Fascínio Especial – Adriana A (Veja 07/12/2016)"
  },
  {
    "name": "Brinco Fértil",
    "value": 4010,
    "date": "19/08/2008",
    "extra": "Adriana Ancelmo - Joalheria AB"
  },
  {
    "name": "Anel Black Cluster Especial",
    "value": 30000,
    "date": "10/12/2012",
    "extra": "Carlos Miranda - Joalheria AB"
  },
  {
    "name": "Colar Delus com pérola barroca",
    "value": 42000,
    "date": "11/06/2012",
    "extra": "Carlos Miranda - Joalheria AB"
  },
  {
    "name": "Brinco Pierrot",
    "value": 28500,
    "date": "10/04/2012",
    "extra": "Carlos Miranda - Joalheria AB"
  },
  {
    "name": "Brinco Eva",
    "value": 33750,
    "date": "10/02/2012",
    "extra": "Carlos Miranda - Joalheria AB"
  },
  {
    "name": "Aliança Dany ballet",
    "value": 518,
    "date": "16/01/2012",
    "extra": "Carlos Miranda - Joalheria AB"
  },
  {
    "name": "Brinco espeto Flash",
    "value": 923,
    "date": "16/01/2012",
    "extra": "Carlos Miranda - Joalheria AB"
  },
  {
    "name": "Aliança Dany Color com esmeralda",
    "value": 659,
    "date": "16/01/2012",
    "extra": "Carlos Miranda - Joalheria AB"
  },
  {
    "name": "Colar Encanto",
    "value": 4900,
    "date": "30/09/2011",
    "extra": "Carlos Miranda - Joalheria AB"
  },
  {
    "name": "Aliança Dany com diamante",
    "value": 598,
    "date": "30/06/2011",
    "extra": "Carlos Miranda - Joalheria AB"
  },
  {
    "name": "Aliança Dany Ritmo",
    "value": 515,
    "date": "30/06/2011",
    "extra": "Carlos Miranda - Joalheria AB"
  },
  {
    "name": "Aliança Dany Concreta",
    "value": 515,
    "date": "30/06/2011",
    "extra": "Carlos Miranda - Joalheria AB"
  },
  {
    "name": "Anel Celebration",
    "value": 3994,
    "date": "30/06/2011",
    "extra": "Carlos Miranda - Joalheria AB"
  },
  {
    "name": "Anel Arena",
    "value": 1144,
    "date": "30/06/2011",
    "extra": "Carlos Miranda - Joalheria AB"
  },
  {
    "name": "Aliança Dany color com rubi",
    "value": 598,
    "date": "30/11/2011",
    "extra": "Carlos Miranda - Joalheria AB"
  },
  {
    "name": "Colar Bolero com safira azul",
    "value": 34936,
    "date": "30/11/2011",
    "extra": "Carlos Miranda - Joalheria AB"
  },
  {
    "name": "Anel Mozart com diamante",
    "value": 51000,
    "date": "01/01/2010",
    "extra": "Carlos Miranda - Joalheria AB"
  },
  {
    "name": "Cordão Veneziano 42",
    "value": 660,
    "date": "16/12/2010",
    "extra": "Carlos Miranda - Joalheria AB"
  },
  {
    "name": "Cordão couro pequeno",
    "value": 286,
    "date": "16/12/2010",
    "extra": "Carlos Miranda - Joalheria AB"
  },
  {
    "name": "Pingente Japão",
    "value": 466,
    "date": "16/12/2010",
    "extra": "Carlos Miranda - Joalheria AB"
  },
  {
    "name": "Pingente Eu e você",
    "value": 581,
    "date": "16/12/2010",
    "extra": "Carlos Miranda - Joalheria AB"
  },
  {
    "name": "Colar Entre",
    "value": 34213,
    "date": "16/12/2010",
    "extra": "Carlos Miranda - Joalheria AB"
  },
  {
    "name": "Colar Flash com diamante",
    "value": 1425,
    "date": "16/12/2010",
    "extra": "Carlos Miranda - Joalheria AB"
  },
  {
    "name": "Brinco Fitas",
    "value": 5671,
    "date": "16/12/2010",
    "extra": "Carlos Miranda - Joalheria AB"
  },
  {
    "name": "02 alianças lisa com diamante",
    "value": 2800,
    "date": "14/04/2010",
    "extra": "Carlos Miranda - Joalheria AB"
  },
  {
    "name": "Aliança Mais Realce",
    "value": 16975,
    "date": "09/02/2010",
    "extra": "Carlos Miranda - Joalheria AB"
  },
  {
    "name": "Colar líquido II com bead",
    "value": 26800,
    "date": "01/01/2009",
    "extra": "Carlos Miranda - Joalheria AB"
  },
  {
    "name": "Brinco espeto Embrace diamante",
    "value": 24445,
    "date": "09/02/2010",
    "extra": "Carlos Miranda - Joalheria AB"
  },
  {
    "name": "Colar Lovely",
    "value": 8460,
    "date": "29/04/2009",
    "extra": "Carlos Miranda - Joalheria AB"
  },
  {
    "name": "Anel Blume com granadas",
    "value": 9060,
    "date": "10/12/2008",
    "extra": "Carlos Miranda - Joalheria AB"
  },
  {
    "name": "Anel múltiplos",
    "value": 4165,
    "date": "10/12/2008",
    "extra": "Carlos Miranda - Joalheria AB"
  },
  {
    "name": "Colar Satélite com quartzo",
    "value": 15555,
    "date": "10/12/2008",
    "extra": "Carlos Miranda - Joalheria AB"
  },
  {
    "name": "Brinco Entre",
    "value": 5068,
    "date": "07/05/2008",
    "extra": "Carlos Miranda - Joalheria AB"
  },
  {
    "name": "Colar Botânico",
    "value": 3128,
    "date": "01/02/2008",
    "extra": "Carlos Miranda - Joalheria AB"
  },
  {
    "name": "Anel Revelação",
    "value": 8364,
    "date": "01/02/2008",
    "extra": "Carlos Miranda - Joalheria AB"
  },
  {
    "name": "Anel Layer",
    "value": 3060,
    "date": "18/01/2008",
    "extra": "Carlos Miranda - Joalheria AB"
  },
  {
    "name": "Colar Mimo",
    "value": 1150,
    "date": "29/10/2007",
    "extra": "Carlos Miranda - Joalheria AB"
  },
  {
    "name": "Anel Casa",
    "value": 4900,
    "date": "29/10/2007",
    "extra": "Carlos Miranda - Joalheria AB"
  },
  {
    "name": "Brinco Hug",
    "value": 2039,
    "date": "27/09/2007",
    "extra": "Carlos Miranda - Joalheria AB"
  },
  {
    "name": "Brinco Vivo Longo",
    "value": 4053,
    "date": "27/09/2007",
    "extra": "Carlos Miranda - Joalheria AB"
  },
  {
    "name": "Brinco Leaves",
    "value": 5628,
    "date": "18/04/2007",
    "extra": "Carlos Miranda - Joalheria AB"
  },
  {
    "name": "Brinco impulso",
    "value": 1785,
    "date": "26/02/2007",
    "extra": "Carlos Miranda - Joalheria AB"
  },
  {
    "name": "Colar de ouro nobre 18K com diamante",
    "value": 81000,
    "date": "01/05/2013",
    "extra": "Cabral - Joalheria HS"
  },
  {
    "name": "Anel de ouro nobre 18K com diamante",
    "value": 30000,
    "date": "01/05/2013",
    "extra": "Cabral - Joalheria HS"
  },
  {
    "name": "Anel de ouro branco 18K com brilhante",
    "value": 319000,
    "date": "01/08/2014",
    "extra": "Cabral - Joalheria HS",
    "description": "A joalheria H.Stern encaminhou à Operação Calicute, ‘notas fiscais e certificados’ de compras de Sérgio Cabral, de sua mulher a advogada Adriana Ancelmo e de outros investigados na Calicute. Juntos, Sérgio e Adriana Cabral gastaram menos R$ 1.931.828,00 em joias, segundo as notas fiscais entregues pela H.Stern (Estadão 28/11/2016)"
  },
  {
    "name": "Anel de ouro branco 18K com esmeralda",
    "value": 342000,
    "date": "01/08/2015",
    "extra": "Cabral - Joalheria HS",
    "description": "O ex-governador do Rio Sérgio Cabral (PMDB) gastou R$ 1,372 milhão em quatro anéis e um colar da H. Stern, entre 2013 e 2015, segundo notas fiscais entregues pela joalheria à Polícia Federal. Foram comprados, entre outros, um anel de ouro branco 18k com esmeralda por R$ 342 mil (Estadão 28/11/2016)"
  },
  {
    "name": "Brinco de ouro amarelo 18K com rubi",
    "value": 400000,
    "date": "01/04/2014",
    "extra": "Cabral - Joalheria HS",
    "description": "A espantosa quantia de R$ 1 milhão de dinheiro oriundo de corrupção e outros ilícitos, foram utilizados por Cabral para presentear a esposa Adriana Ancelmo com um conjunto de brincos e anel de rubis, no mês de abril de 2014, quando completaram 10 anos de matrimônio, aponta a denúncia da Procuradoria contra o ex-governador do Rio (O Dia 06/12/2016)"
  },
  {
    "name": "Anel de ouro amarelo 18K com rubi",
    "value": 600000,
    "date": "01/04/2014",
    "extra": "Cabral - Joalheria HS",
    "description": "Sérgio Cabral pagou R$ 1 milhão por um conjunto que incluía um anel de ouro amarelo 18k com rubi na joalheria H.Stern. As joias foram compradas para celebrar os 10 anos de casamento com a advogada Adriana Ancelmo em abril de 2014, mês que o peemedebista deixou o governo do Rio (Estadão 06/12/2016)"
  },
  {
    "name": "Brinco de ouro branco 18K com turmalina",
    "value": 305000,
    "date": "01/08/2012",
    "extra": "Adriana Ancelmo - Joalheria HS",
    "description": "Em depoimento à Polícia Federal, a diretora comercial da H.Stern, Maria Luiza Trotta, afirmou que levava joias, anéis de brilhante e pedras preciosas, na residência de Sérgio Cabral, para que o ex-governador e sua mulher Adriana Ancelmo fizessem uma ‘seleção’ da peça a ser escolhida. Segundo Maria Trotta, os pagamentos era feitos em dinheiro vivo (Estadão 28/11/2016)"
  },
  {
    "name": "Brinco de ouro nobre 18K com esmeralda",
    "value": 50000,
    "date": "01/12/2013",
    "extra": "Adriana Ancelmo - Joalheria HS"
  },
  {
    "name": "Colar de ouro nobre",
    "value": 165000,
    "date": "01/12/2013",
    "extra": "Adriana Ancelmo - Joalheria HS",
    "description": "As notas fiscais e certificados encaminhados à Polícia Federal pela joalheria H.Stern são referentes ao casal Cabral, aos supostos operadores do ex-governador e as respectivas mulheres. Em dezembro de 2013, uma nota fiscal aponta que Adriana Ancelmo comprou um colar de ouro nobre 18k com esmeralda, por R$ 165 mil (Estadão 28/11/2016)"
  }
];
